function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  viewBox: "0 0 72 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M36.0391 71L36.0391 -1.13249e-06",
  stroke: "#370E7B",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.0781 43.9063L36.0392 70.8594L1.0002 43.9063",
  stroke: "#370E7B",
  strokeWidth: "2"
}));